<template>
  <div>
    <section v-if="!price" class="Pricing">
      <ul>
        <li>
          <div class="title">Trial</div>
          <div class="cost">FREE</div>
          <div class="content">
            <p>{{ $t("advertise") }}</p>
            <p>다중파일작업</p>
            <p>1회 최대 1M btye 변환</p>
          </div>
          <p class="take">1Mbtye</p>
          <a class="payment">무료</a>
        </li>
        <li>
          <div class="title">Basic</div>
          <div class="cost">$1</div>
          <div class="content">
            <p>{{ $t("advertise") }}</p>
            <p>다중파일작업</p>
            <p>1회 최대 10Mbtye 변환</p>
          </div>
          <p class="take">10Mbtye 변환</p>
          <a class="payment" @click="handleCharge(1, '101')">결제하기</a>
        </li>
        <li>
          <div class="title">Premium</div>
          <div class="cost">$10</div>
          <div class="content">
            <p>{{ $t("advertise") }}</p>
            <p>다중파일작업</p>
            <p>1회 최대 100Mbtye 변환</p>
          </div>
          <p class="take">100Mbtye 변환</p>
          <a class="payment" @click="handleCharge(10, '102')">결제하기</a>
        </li>
      </ul>
    </section>
    <Charge v-else :price="price" :serviceCode="serviceCode" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Charge from "./Charge";

export default {
  components: {
    Charge,
  },
  data() {
    return {
      price: null,
      serviceCode: "",
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", 4);
  },
  computed: {
    ...mapState(["isLogin"]),
  },
  methods: {
    handleCharge(price, serviceCode) {
      if (!this.isLogin) {
        return alert("로그인 후 이용해 주세요.");
      }
      this.price = price;
      this.serviceCode = serviceCode;
    },
  },
};
</script>
<style lang="scss" scoped>
.Pricing {
  max-width: 1100px;
  margin: 150px auto;
  ul {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    color: #313da1;
    li {
      text-align: center;
      &:hover {
        border: 2px solid red;
      }
      border: 2px solid #313da1;
      border-radius: 10px;
      width: 250px;
      height: 440px;
      padding: 15px;
      .title {
        margin: 12px 0;
      }
      .cost {
        text-align: center;
        font-size: 1.9rem;
        font-weight: bold;
        margin: 34px 0;
      }
      .content {
        padding: 10px;
        border-top: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
        line-height: 3rem;
      }
      .take {
        margin-top: 20px;
        font-size: 1.8rem;
        line-height: 3.6rem;
        font-weight: 450;
      }
      .payment {
        margin: 40px 0;
        font-weight: bold;
        font-size: 1.4rem;
        background-color: #313da1;
        color: #fff;
        padding: 0;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
@media screen and (max-width: 769px) {
  .Pricing {
    width: calc(100% - 20px);
    ul {
      li {
        width: 45%;
        height: 400px;
        padding: 15px;
        margin: 20px auto;
        .payment {
          margin: 20px 0;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .Pricing {
    width: calc(100% - 10px);
    ul {
      li {
        width: 95%;
        height: 360px;
        .cost {
          margin: 20px 0;
        }
        .take {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
